import { useEffect } from 'react';
import type { ConnectedContentInlineModel } from 'autogen/swagger/all';
import { CustomActionDiscriminator } from 'autogen/swagger/all';
import { guardIsPageActionOfTypeCustomAction } from 'components/shared/Routing/components/shared/helpers';
import ConnectedContentSurveyItem from 'components/surveySystem/components/ConnectedContentSurveyItem';
import { useOpenSurveyQuickView } from 'components/surveySystem/shared/hooks/useOpenSurveyQuickView';
import InlineConnectedContentCard from './InlineConnectedContent';
import type { IExtendedInlineModel } from './shared/interfaces';

export interface IInlineConnectedContent {
    model: IExtendedInlineModel;
}

export default function InlineConnectedContent({ model }: { model: ConnectedContentInlineModel }): JSX.Element {
    const { link, openAsModalProactively } = model;
    const customAction = guardIsPageActionOfTypeCustomAction(link?.pageAction);
    const { openSurveyQuickViewBySurveyId } = useOpenSurveyQuickView();

    useEffect(() => {
        if (customAction && openAsModalProactively) {
            const surveyAction = CustomActionDiscriminator(
                customAction.action,
                () => null,
                () => null,
                () => null,
                (surveyModel) => surveyModel,
                () => null,
                () => null
            );

            if (surveyAction?.surveyId) openSurveyQuickViewBySurveyId({ surveyId: surveyAction.surveyId });
        }
    }, [link, openAsModalProactively]);

    /*
        We display the first survey question directly in the connectedContent item if it has surveyQuestion
    */
    if (model.surveyQuestion) {
        return <ConnectedContentSurveyItem model={model} type={'ConnectedContentInline'} />;
    }

    return <InlineConnectedContentCard model={model} />;
}
